<app-spinner-service></app-spinner-service>
<p-confirmDialog></p-confirmDialog>

<div class="dividendos-page" [class.dividendos-page--loading]="isLoading">
  <fieldset class="form-block filtros-block">
    <legend class="form-block-legend">Filtros</legend>

    <div class="filtros-grid">
      <div class="filtro-item">
        <label for="filtroDataInicio">Data início</label>
        <p-calendar
          inputId="filtroDataInicio"
          [(ngModel)]="filtroDataInicio"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          appendTo="body"
          placeholder="dd/mm/aaaa"
          styleClass="w-full">
        </p-calendar>
      </div>

      <div class="filtro-item">
        <label for="filtroDataFim">Data fim</label>
        <p-calendar
          inputId="filtroDataFim"
          [(ngModel)]="filtroDataFim"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          appendTo="body"
          placeholder="dd/mm/aaaa"
          styleClass="w-full">
        </p-calendar>
      </div>

      <div class="filtro-item">
        <label for="filtroTipo">Tipo de distribuição</label>
        <p-dropdown
          inputId="filtroTipo"
          [options]="formasDistribuicao"
          [(ngModel)]="filtroFormaDistribuicao"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="Todos"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="filtro-item">
        <label for="filtroBeneficiario">Beneficiário</label>
        <p-dropdown
          inputId="filtroBeneficiario"
          [options]="socios"
          [(ngModel)]="filtroSocioId"
          optionLabel="nmTrab"
          optionValue="id"
          [showClear]="true"
          placeholder="Todos"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="filtro-item">
        <label for="filtroStatusReinf">Status REINF</label>
        <p-dropdown
          inputId="filtroStatusReinf"
          [options]="statusReinfOptions"
          [(ngModel)]="filtroStatusReinf"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="Todos"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="filtro-actions">
        <button pButton label="Limpar" icon="pi pi-filter-slash" class="p-button-outlined p-button-secondary" (click)="limparFiltros()"></button>
        <button pButton label="Filtrar" icon="pi pi-filter" (click)="aplicarFiltros()"></button>
      </div>
    </div>
  </fieldset>

  <app-toolbar-search (onSearch)="applyFilterGlobal($event)" placeholder="Pesquisar dividendos...">
    <div leftContent class="toolbar-actions">
      <button pButton label="Nova Distribuição" icon="pi pi-plus" [disabled]="isLoading" (click)="openNew()"></button>
      <button pButton label="Exportar Excel" icon="pi pi-file-excel" class="p-button-outlined" [disabled]="isLoading" (click)="exportarExcel()"></button>
    </div>
  </app-toolbar-search>

  <p-table #dt [value]="dividendos"
    [globalFilterFields]="['formaDistribuicaoDescricao', 'statusDividendoDescricao', 'statusReinfDescricao', 'valorBrutoTotal']"
    [paginator]="true"
    [rows]="10"
    responsiveLayout="scroll"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    class="custom-table"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 20, 50]"
    sortField="dataDistribuicao"
    [sortOrder]="-1">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="dataDistribuicao" style="width: 12%">Data Distribuição <p-sortIcon field="dataDistribuicao"></p-sortIcon></th>
        <th pSortableColumn="formaDistribuicaoDescricao" style="width: 18%">Tipo <p-sortIcon field="formaDistribuicaoDescricao"></p-sortIcon></th>
        <th pSortableColumn="valorBrutoTotal" style="width: 12%">Valor Total <p-sortIcon field="valorBrutoTotal"></p-sortIcon></th>
        <th pSortableColumn="valorIrTotal" style="width: 10%">IR <p-sortIcon field="valorIrTotal"></p-sortIcon></th>
        <th style="width: 12%">Status REINF</th>
        <th style="width: 8%">Beneficiários</th>
        <th pSortableColumn="statusDividendoDescricao" style="width: 10%">Pagamento <p-sortIcon field="statusDividendoDescricao"></p-sortIcon></th>
        <th style="width: 12%" class="text-center">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-dividendo>
      <tr>
        <td>
          <div class="date-content">
            <i class="pi pi-calendar date-icon"></i>
            <span class="date-text">{{ dividendo.dataDistribuicao | date:'dd/MM/yyyy' }}</span>
          </div>
        </td>
        <td>
          <div class="type-content">
            <i class="pi pi-chart-line type-icon"></i>
            <span class="type-text" [pTooltip]="dividendo.formaDistribuicaoDescricao" tooltipPosition="top">{{ dividendo.formaDistribuicaoDescricao }}</span>
          </div>
        </td>
        <td>
          <div class="value-content">
            <i class="pi pi-dollar value-icon"></i>
            <span class="value-text">{{ dividendo.valorBrutoTotal | currency:'BRL' }}</span>
          </div>
        </td>
        <td>
          <div class="ir-content">
            <i class="pi pi-percentage ir-icon"></i>
            <span class="ir-text">{{ dividendo.valorIrTotal | currency:'BRL' }}</span>
          </div>
        </td>
        <td>
          <div class="status-content">
            <span class="status-badge status-reinf">{{ dividendo.statusReinfDescricao }}</span>
          </div>
        </td>
        <td>
          <div class="beneficiarios-content">
            <i class="pi pi-users beneficiarios-icon"></i>
            <span class="beneficiarios-text">{{ dividendo.quantidadeBeneficiarios }}</span>
          </div>
        </td>
        <td>
          <p-tag
            [value]="dividendo.statusDividendoDescricao"
            [severity]="getStatusSeverity(dividendo.statusDividendoDescricao)">
          </p-tag>
        </td>
        <td class="text-center">
          <div class="actions-content">
            <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info action-button" (click)="verDetalhes(dividendo)" pTooltip="Detalhes" tooltipPosition="top"></button>
            <button pButton icon="pi pi-refresh" class="p-button-rounded p-button-warning action-button" *ngIf="dividendo.podeRetificar" (click)="retificar(dividendo)" pTooltip="Retificar" tooltipPosition="top"></button>
            <button pButton icon="pi pi-times" class="p-button-rounded p-button-danger action-button" *ngIf="dividendo.podeCancelar" (click)="cancelar(dividendo)" pTooltip="Cancelar" tooltipPosition="top"></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="empty-message">
          <div class="empty-content">
            <i class="pi pi-chart-line empty-icon"></i>
            <h3>Nenhum dividendo cadastrado</h3>
            <p>Cadastre a primeira distribuição de dividendos aos sócios da empresa.</p>
            <button pButton label="Nova Distribuição" icon="pi pi-plus" (click)="openNew()"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<app-dividendos-detalhes [(visible)]="exibirDetalhes" [dividendo]="dividendoSelecionado"></app-dividendos-detalhes>
